import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';
import './InitialTextMerchantAccreditationPolicy.style.scss';

export const InitialTextMerchantAccreditationPolicy = () => {
  return (
    <article className="initial-text-merchant-policy">
      <DynamicContent
        configPath={REMOTE_CONFIG_PATHS.MERCHANT_POLICY.INITIAL_TEXT}
        renderAsHtml={true}
      />
    </article>
  );
};
